<template>
  <select
    v-model="value"
    :id="name"
    :name="name"
    class="form-control input-lg reload-companies"
    :class="{ 'has-error': !!errorMessage }"
    @change="handleChange"
  >
    <option v-if="defaultItem" :value="defaultItem.value">
      {{ defaultItem.label }}
    </option>
    <option
      v-for="(item, idx) in selectableItems"
      :key="idx"
      :value="item.value"
    >
      {{ item.label }}
    </option>
  </select>
</template>

<script setup>
import { watch, computed } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";

const store = useStore();

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  selectableItems: {
    type: Array,
    required: true
  },
  defaultItem: {
    type: Object,
    required: false
  },
  validator: { type: Object, required: true },
  dispatcher: { type: String, required: true }
});

const initialValue = computed(() => store.state.formData[props.name]);

const { value, errorMessage } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: initialValue.value || null
});
const { validate } = useForm();
const handleChange = async () => {
  await validate();
};
watch(value, newValue => store.dispatch(props.dispatcher, newValue));
watch(
  () => props.selectableItems,
  () => {
    if (!props.selectableItems.find(item => item.value == value.value)) {
      value.value = null;
    }
  }
);
</script>
